export const state = {
    appName: 'BIGCRAZY24',
    user: null,
    error: null,
    loading: false,
    access_token: null,
    isAuth: false,
    layout: 'app-layout',
    line_id: '@anb88',
    logoUrl: '',
    theme: '',
    gameList: '',
    promotion: [],
    prefix: '',
    isAuth: false,
    alertImage: '',
    alertMessage: '',
    img_affiliate: null,
    img_cashback: null,
}


// WEBPACK FOOTER //
// ./src/store/modules/state.js